import {
  faA,
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAnglesRight,
  faAngleUp,
  faArrowDown,
  faArrowDownFromDottedLine,
  faArrowLeft,
  faArrowPointer,
  faArrowRight,
  faArrowsMinimize,
  faArrowsRotate,
  faArrowsToLine,
  faArrowsUpDownLeftRight,
  faArrowTrendUp,
  faArrowUp,
  faArrowUpRight,
  faAsterisk,
  faBadgeDollar,
  faBallPile,
  faBarcode,
  faBars,
  faBarsFilter,
  faBasketShopping,
  faBell,
  faBellOn,
  faBook,
  faBookBookmark,
  faBookmark,
  faBorderAll,
  faBorderOuter,
  faBorderTopLeft,
  faBox,
  faBoxArchive,
  faCalendar,
  faCalendarClock,
  faCalendarDay,
  faCalendarDays,
  faCalendarPlus,
  faCalendarRange,
  faCalendarWeek,
  faCamera,
  faCartArrowDown,
  faCartArrowUp,
  faCartShopping,
  faChartArea,
  faChartBar,
  faChartColumn,
  faChartLine,
  faChartMixedUpCircleDollar,
  faCheck,
  faChevronCircleDown,
  faChevronCircleUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronsRight,
  faChevronsUp,
  faChevronUp,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleMinus,
  faCircleNotch,
  faCirclePlay,
  faCirclePlus,
  faCircleQuestion,
  faCircleSmall,
  faCircleUser,
  faCircleXmark,
  faClipboard,
  faClock,
  faClockRotateLeft,
  faClone,
  faCloudsMoon,
  faCoins,
  faComment,
  faCompress,
  faComputerMouse,
  faCopy,
  faDisplay,
  faDown,
  faDownload,
  faEllipsis,
  faEllipsisH,
  faEllipsisVertical,
  faEnvelope,
  faEnvelopeOpenText,
  faExclamation,
  faExclamationTriangle,
  faExpand,
  faEye,
  faEyeSlash,
  faFeatherPointed,
  faFileArrowDown,
  faFileExcel,
  faFileInvoice,
  faFilePdf,
  faFilePen,
  faFilePlus,
  faFillDrip,
  faFilter,
  faFireFlameCurved,
  faFlag,
  faFolderArrowDown,
  faFolderOpen,
  faFont,
  faGear,
  faGhost,
  faGrid2,
  faGrid2Plus,
  faGripDots,
  faGripDotsVertical,
  faHand,
  faHeart,
  faHourglassEnd,
  faImage,
  faImagePolaroid,
  faIndent,
  faIndustryWindows,
  faInfinity,
  faLayerGroup,
  faLeft,
  faLeftRight,
  faLightbulbDollar,
  faLink,
  faList,
  faListTree,
  faLocationDot,
  faLock,
  faMagnifyingGlass,
  faMagnifyingGlassDollar,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faMars,
  faMedal,
  faMegaphone,
  faMemo,
  faMemoCircleCheck,
  faMerge,
  faMessage,
  faMessageLines,
  faMinus,
  faMobileScreen,
  faMoneyCheckDollar,
  faNoteSticky,
  faObjectGroup,
  faPaintbrushPencil,
  faPaperPlane,
  faPause,
  faPen,
  faPencil,
  faPenNib,
  faPersonChalkboard,
  faPhoneSlash,
  faPhotoFilm,
  faPlay,
  faPlus,
  faPrint,
  faRepeat,
  faRight,
  faRotateLeft,
  faRotateRight,
  faShapes,
  faShareNodes,
  faShieldHalved,
  faShirt,
  faSliders,
  faSpinner,
  faSquare,
  faSquareDollar,
  faSquareInfo,
  faSquarePlus,
  faSquareQuestion,
  faSquareSlidersVertical,
  faStar,
  faStore,
  faTableCellsLarge,
  faTag,
  faText,
  faThumbsDown,
  faThumbsUp,
  faThumbTack,
  faTrash,
  faTrashCan,
  faTrashList,
  faTriangleExclamation,
  faTrophyStar,
  faTruck,
  faTruckFast,
  faUp,
  faUpDown,
  faUpload,
  faUpRightAndDownLeftFromCenter,
  faUser,
  faUsers,
  faVenus,
  faVenusMars,
  faVideo,
  faVideoArrowUpRight,
  faVolume,
  faVolumeSlash,
  faWandMagicSparkles,
  faWindowMinimize,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons';

export const fas = {
  [faArrowTrendUp.iconName]: faArrowTrendUp,
  [faBars.iconName]: faBars,
  [faCircleNotch.iconName]: faCircleNotch,
  [faExclamationTriangle.iconName]: faExclamationTriangle,
  [faBell.iconName]: faBell,
  [faBellOn.iconName]: faBellOn,
  [faVideo.iconName]: faVideo,
  [faPhoneSlash.iconName]: faPhoneSlash,
  [faVideoArrowUpRight.iconName]: faVideoArrowUpRight,
  [faXmark.iconName]: faXmark,
  [faGear.iconName]: faGear,
  [faAngleLeft.iconName]: faAngleLeft,
  [faLeft.iconName]: faLeft,
  [faRight.iconName]: faRight,
  [faUp.iconName]: faUp,
  [faDown.iconName]: faDown,
  [faAngleRight.iconName]: faAngleRight,
  [faAngleDown.iconName]: faAngleDown,
  [faAngleUp.iconName]: faAngleUp,
  [faCircleUser.iconName]: faCircleUser,
  [faBook.iconName]: faBook,
  [faBookmark.iconName]: faBookmark,
  [faBookBookmark.iconName]: faBookBookmark,
  [faBasketShopping.iconName]: faBasketShopping,
  [faCheck.iconName]: faCheck,
  [faArrowLeft.iconName]: faArrowLeft,
  [faArrowRight.iconName]: faArrowRight,
  [faArrowUp.iconName]: faArrowUp,
  [faArrowUpRight.iconName]: faArrowUpRight,
  [faArrowDown.iconName]: faArrowDown,
  [faImagePolaroid.iconName]: faImagePolaroid,
  [faCalendarClock.iconName]: faCalendarClock,
  [faCalendarDays.iconName]: faCalendarDays,
  [faSpinner.iconName]: faSpinner,
  [faBadgeDollar.iconName]: faBadgeDollar,
  [faBars.iconName]: faBars,
  [faCircleCheck.iconName]: faCircleCheck,
  [faGhost.iconName]: faGhost,
  [faTriangleExclamation.iconName]: faTriangleExclamation,
  [faUpRightAndDownLeftFromCenter.iconName]: faUpRightAndDownLeftFromCenter,
  [faMobileScreen.iconName]: faMobileScreen,
  [faDisplay.iconName]: faDisplay,
  [faMagnifyingGlass.iconName]: faMagnifyingGlass,
  [faMemo.iconName]: faMemo,
  [faMemoCircleCheck.iconName]: faMemoCircleCheck,
  [faCamera.iconName]: faCamera,
  [faComputerMouse.iconName]: faComputerMouse,
  [faCoins.iconName]: faCoins,
  [faEnvelope.iconName]: faEnvelope,
  [faEnvelopeOpenText.iconName]: faEnvelopeOpenText,
  [faLink.iconName]: faLink,
  [faClone.iconName]: faClone,
  [faComment.iconName]: faComment,
  [faEllipsis.iconName]: faEllipsis,
  [faCopy.iconName]: faCopy,
  [faFilePdf.iconName]: faFilePdf,
  [faFilePen.iconName]: faFilePen,
  [faFileExcel.iconName]: faFileExcel,
  [faTrashList.iconName]: faTrashList,
  [faShirt.iconName]: faShirt,
  [faGrid2Plus.iconName]: faGrid2Plus,
  [faChevronDown.iconName]: faChevronDown,
  [faChevronUp.iconName]: faChevronUp,
  [faChevronLeft.iconName]: faChevronLeft,
  [faChevronRight.iconName]: faChevronRight,
  [faChevronCircleDown.iconName]: faChevronCircleDown,
  [faChevronCircleUp.iconName]: faChevronCircleUp,
  [faCalendar.iconName]: faCalendar,
  [faCalendarWeek.iconName]: faCalendarWeek,
  [faCalendarDay.iconName]: faCalendarDay,
  [faCalendarRange.iconName]: faCalendarRange,
  [faObjectGroup.iconName]: faObjectGroup,
  [faPaintbrushPencil.iconName]: faPaintbrushPencil,
  [faPencil.iconName]: faPencil,
  [faTag.iconName]: faTag,
  [faMegaphone.iconName]: faMegaphone,
  [faFireFlameCurved.iconName]: faFireFlameCurved,
  [faLeftRight.iconName]: faLeftRight,
  [faArrowsUpDownLeftRight.iconName]: faArrowsUpDownLeftRight,
  [faUpDown.iconName]: faUpDown,
  [faArrowsMinimize.iconName]: faArrowsMinimize,
  [faArrowsToLine.iconName]: faArrowsToLine,
  [faPen.iconName]: faPen,
  [faTrash.iconName]: faTrash,
  [faTruck.iconName]: faTruck,
  [faBallPile.iconName]: faBallPile,
  [faArrowDownFromDottedLine.iconName]: faArrowDownFromDottedLine,
  [faLayerGroup.iconName]: faLayerGroup,
  [faRotateLeft.iconName]: faRotateLeft,
  [faArrowsRotate.iconName]: faArrowsRotate,
  [faAsterisk.iconName]: faAsterisk,
  [faEllipsisVertical.iconName]: faEllipsisVertical,
  [faLock.iconName]: faLock,
  [faCircleInfo.iconName]: faCircleInfo,
  [faFeatherPointed.iconName]: faFeatherPointed,
  [faThumbTack.iconName]: faThumbTack,
  [faIndustryWindows.iconName]: faIndustryWindows,
  [faInfinity.iconName]: faInfinity,
  [faFolderArrowDown.iconName]: faFolderArrowDown,
  [faFilePlus.iconName]: faFilePlus,
  [faCircleQuestion.iconName]: faCircleQuestion,
  [faSquareQuestion.iconName]: faSquareQuestion,
  [faTruckFast.iconName]: faTruckFast,
  [faCartShopping.iconName]: faCartShopping,
  [faCartArrowUp.iconName]: faCartArrowUp,
  [faChartBar.iconName]: faChartBar,
  [faChartLine.iconName]: faChartLine,
  [faChartColumn.iconName]: faChartColumn,
  [faChartArea.iconName]: faChartArea,
  [faChartMixedUpCircleDollar.iconName]: faChartMixedUpCircleDollar,
  [faStore.iconName]: faStore,
  [faShieldHalved.iconName]: faShieldHalved,
  [faCalendarPlus.iconName]: faCalendarPlus,
  [faShapes.iconName]: faShapes,
  [faFileArrowDown.iconName]: faFileArrowDown,
  [faCloudsMoon.iconName]: faCloudsMoon,
  [faCircleExclamation.iconName]: faCircleExclamation,
  [faFlag.iconName]: faFlag,
  [faShareNodes.iconName]: faShareNodes,
  [faEllipsisH.iconName]: faEllipsisH,
  [faDownload.iconName]: faDownload,
  [faVolume.iconName]: faVolume,
  [faVolumeSlash.iconName]: faVolumeSlash,
  [faClipboard.iconName]: faClipboard,
  [faUsers.iconName]: faUsers,
  [faEye.iconName]: faEye,
  [faEyeSlash.iconName]: faEyeSlash,
  [faClock.iconName]: faClock,
  [faCirclePlus.iconName]: faCirclePlus,
  [faCircleMinus.iconName]: faCircleMinus,
  [faCircleXmark.iconName]: faCircleXmark,
  [faFolderOpen.iconName]: faFolderOpen,
  [faFileInvoice.iconName]: faFileInvoice,
  [faLocationDot.iconName]: faLocationDot,
  [faPrint.iconName]: faPrint,
  [faMinus.iconName]: faMinus,
  [faPlus.iconName]: faPlus,
  [faTrashCan.iconName]: faTrashCan,
  [faSquareSlidersVertical.iconName]: faSquareSlidersVertical,
  [faSliders.iconName]: faSliders,
  [faFilter.iconName]: faFilter,
  [faBarsFilter.iconName]: faBarsFilter,
  [faPenNib.iconName]: faPenNib,
  [faUpload.iconName]: faUpload,
  [faRepeat.iconName]: faRepeat,
  [faCirclePlay.iconName]: faCirclePlay,
  [faHourglassEnd.iconName]: faHourglassEnd,
  [faBox.iconName]: faBox,
  [faSquare.iconName]: faSquare,
  [faGrid2.iconName]: faGrid2,
  [faStar.iconName]: faStar,
  [faMessage.iconName]: faMessage,
  [faMessageLines.iconName]: faMessageLines,
  [faAnglesRight.iconName]: faAnglesRight,
  [faTrophyStar.iconName]: faTrophyStar,
  [faList.iconName]: faList,
  [faListTree.iconName]: faListTree,
  [faCircleSmall.iconName]: faCircleSmall,
  [faSquareInfo.iconName]: faSquareInfo,
  [faMoneyCheckDollar.iconName]: faMoneyCheckDollar,
  [faSquareDollar.iconName]: faSquareDollar,
  [faLightbulbDollar.iconName]: faLightbulbDollar,
  [faMagnifyingGlassDollar.iconName]: faMagnifyingGlassDollar,
  [faMedal.iconName]: faMedal,
  [faChevronsUp.iconName]: faChevronsUp,
  [faClockRotateLeft.iconName]: faClockRotateLeft,
  [faHeart.iconName]: faHeart,
  [faUser.iconName]: faUser,
  [faPaperPlane.iconName]: faPaperPlane,
  [faExpand.iconName]: faExpand,
  [faCompress.iconName]: faCompress,
  [faExclamation.iconName]: faExclamation,
  [faWandMagicSparkles.iconName]: faWandMagicSparkles,
  [faWindowMinimize.iconName]: faWindowMinimize,
  [faChevronsRight.iconName]: faChevronsRight,
  [faAlignLeft.iconName]: faAlignLeft,
  [faAlignRight.iconName]: faAlignRight,
  [faAlignCenter.iconName]: faAlignCenter,
  [faAlignJustify.iconName]: faAlignJustify,
  [faA.iconName]: faA,
  [faFillDrip.iconName]: faFillDrip,
  [faBorderAll.iconName]: faBorderAll,
  [faBorderOuter.iconName]: faBorderOuter,
  [faBorderTopLeft.iconName]: faBorderTopLeft,
  [faIndent.iconName]: faIndent,
  [faText.iconName]: faText,
  [faSquarePlus.iconName]: faSquarePlus,
  [faMerge.iconName]: faMerge,
  [faPhotoFilm.iconName]: faPhotoFilm,
  [faGripDots.iconName]: faGripDots,
  [faGripDotsVertical.iconName]: faGripDotsVertical,
  [faMars.iconName]: faMars,
  [faVenus.iconName]: faVenus,
  [faVenusMars.iconName]: faVenusMars,
  [faArrowPointer.iconName]: faArrowPointer,
  [faHand.iconName]: faHand,
  [faNoteSticky.iconName]: faNoteSticky,
  [faFont.iconName]: faFont,
  [faMagnifyingGlassPlus.iconName]: faMagnifyingGlassPlus,
  [faMagnifyingGlassMinus.iconName]: faMagnifyingGlassMinus,
  [faPersonChalkboard.iconName]: faPersonChalkboard,
  [faCartArrowDown.iconName]: faCartArrowDown,
  [faTableCellsLarge.iconName]: faTableCellsLarge,
  [faThumbsUp.iconName]: faThumbsUp,
  [faThumbsDown.iconName]: faThumbsDown,
  [faRotateRight.iconName]: faRotateRight,
  [faBoxArchive.iconName]: faBoxArchive,
  [faImage.iconName]: faImage,
  [faPlay.iconName]: faPlay,
  [faPause.iconName]: faPause,
  [faBarcode.iconName]: faBarcode,
};
